'use strict';

import { base, io, Component, PropTypes, update, sub, fromJS, toJS, mq, ReactChildren, Listener, redirect } from 'core';

import { Card as CardPaper, CardHeader, CardMedia, CardTitle, CardText } from 'material-ui';

import { VelocityComponent, VelocityTransitionGroup } from 'velocity-react';

import { debug_ui, google_key } from 'config';

import TwitterWidgetsLoader from 'twitter-widgets';

import $style from './style';

const styles = {
    icon: {
        block: {
            position: 'relative',
            top: 13,
            left: 8,
            marginTop: 0,
            display: 'block',
            fontSize: 28
        },
        inline: {
            position: 'absolute',
            top: 0,
            left: 6,
            marginTop: 10,
            display: 'inline-block',
            fontSize: 28
        }
    },
    title: {
        fontWeight: '500',
        fontSize: 21
    },
    subtitle: {
    }
};

const initialRect = window.document
                          .getElementsByTagName('react')[0]
                          .getBoundingClientRect();

@base({
    styles: [ $style ]
})
class Card extends Component {

    cardColors = [
        { bg: '#0B9FF0', fg: '#ffffff' },
        { bg: '#9BD2FF', fg: '#333333' },
        { bg: '#888888', fg: '#ffffff' },
        { bg: '#dddddd', fg: '#333333' },
        { bg: '#ffffff', fg: '#333333' }
    ];

    onPaperTap = link => {

        const trigger = this._get('trigger');

        (trigger)
            ? (io.emit(trigger, link))
            : (redirect(link));
    };

    state = { width: initialRect.width }

    componentWillUnmount() {

        clearInterval(this.media_interval);
    }

    componentWillUpdate() {

        const { target, media } = this._get().toJS();

        (target == 'twitter')
            && TwitterWidgetsLoader.load(twttr =>
                twttr.widgets.createTimeline("662133004899323905", this.refs.twitter.getDOMNode(), {
                    screenName: "AccedeAutomaoIn"
                }));
    }

    componentDidMount() {

        const { target, media } = this._get().toJS();

        (target == 'twitter')
            && TwitterWidgetsLoader.load(twttr =>
                twttr.widgets.createTimeline("662133004899323905", this.refs.twitter.getDOMNode(), {
                    screenName: "AccedeAutomaoIn"
                }));

        (media && Array.isArray(media))
            && (this.media_interval = setInterval(() => {

                const media_index = (this.state ||{}).media_index || 0;

                this.setState({
                    media_index: (media_index < media.length-1) ? media_index +1 : 0
                });

            }, 5000));
    }

    render() {

        const { width, height } = this.state ||{};

        const { columns = 8, children, onTouchTap, style = {}, w = 1, h = 1, ...props } = this.props;

        const {
            id, title = '', description, media, link, icon = '', target, q, contain, trigger,
            fullDescription, images, videos,
            bg: default_bg,
            fg: default_fg
        } = this._get().toJS();

        const { bg, fg } = _.sample(this.cardColors);

        const media_bg = media && Array.isArray(media) ? media[(this.state ||{}).media_index || 0] : media;

        const icon_big = (icon && !title && !description && !media_bg);

        const outerWidth = (columns > 1)
            ? (w ? `${w*100/columns}%` : 'auto')
            : '100%' ;

        const outerHeight = h * 96 / 6,
              outerHeightDecimals = 100,
              outerHeightCeil = Math.floor(outerHeight) + Math.floor((outerHeight - Math.floor(outerHeight)) * outerHeightDecimals) / outerHeightDecimals;

        const outerStyles = {
            width: outerWidth,
            height: (h ? `${outerHeightCeil}%` : 'auto'),
            padding: '0 15px 15px 0',
            overflow: 'hidden'
        };
        const innerStyles = {
            cursor: (link || (fullDescription
             || (images && images.length > 0)
             || (videos && videos.length > 0))) ? 'pointer' : 'default',
            background: media ? `white url(${media_bg}) 50% 30%` : (default_bg || bg),
            WebkitUserSelect: 'none',
            backgroundSize: contain ? 'contain !important' : 'cover',
            backgroundRepeat: 'no-repeat',
            height: '100%',
            ...style
        };
        const contentStyles = {
            background: media && (title || description) ? 'rgba(20,20,20,0.7)' : 'transparent',
            color: media ? 'white' : '#333',
            overflow: 'hidden',
            position: 'relative',
            minHeight: 55
        };
        const titleColor = media ? 'white' : (default_fg || fg);

        const cardTitleStyle = {
            display: 'inline-block', textAlign: 'right', float: 'right',
            paddingLeft: icon? 50 : 16, paddingTop: 5
        };
        const subtitleStyle = { paddingTop: title? 0 : 10 }

        const iconStyle = {
            ...styles.icon.inline, color: ((icon_big && bg != '#ffffff' && bg != 'white') ? '#ffffff' : titleColor)
        };

        if (target == 'twitter')
            return (
                <div className="grid-card" style={ outerStyles }>
                    <a href="https://twitter.com/AccedeAutomaoIn" className="twitter-timeline" ref="twitter"
                       data-widget-id="662133004899323905"
                       data-chrome="noborders noscrollbar noheader"/>
                </div>
            );

        if (target == 'map')
            return (
                <div className="grid-card" style={ outerStyles }>
                    <iframe src={`https://www.google.com/maps/embed/v1/place?q=${q}&key=${google_key}`}
                            width="100%" height="100%" frameBorder="0" allowFullScreen />
                </div>
            );

        if (target == 'cases') {

            const casesClients = [
                'agco.png', 'bosch.png',
                'chassisbrakes.png', 'cummins.jpg', 'dmdrava.png', 'drpromaq.png',
                'faurecia.png',
                'komatsu.png', 'kspg.png', 'pierburg.jpg', 'platina.png', 'proglass.png',
                'scania.jpg', 'sew.png', 'toledo2.png',
                'trw.png', 'valeo2.png', 'volvo2.png', 'wabco2.png', 'yaskawa.png'
            ];

            const casesCards = casesClients.map( client =>
                <div key={client}
                     style={{ maxHeight: '18%',
                              display: 'flex',
                              padding: '1%',
                              alignItems: 'center' }}>
                    <img src={`/media/clients/${client}`}
                         className="casesCards-image"/>
                </div>);

            return (
                <div className="grid-card"
                     style={ outerStyles }>
                    <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignContent: 'space-around',
                            justifyContent: 'space-around',
                            overflow: 'hidden',
                            padding: 15,
                            height: '100%',
                            backgroundColor: '#fff',
                            boxShadow: '1px 1px 10px -2px #999' }}>
                        { casesCards }
                    </div>
                </div>
            );

        } else {

            const Description = <span dangerouslySetInnerHTML={{ __html: description }} />;

            const cardContent = (
                <div style={ contentStyles }>
                    <i className={`icon-${icon} ${icon_big ? 'card-icon-big':''}`} style={ iconStyle } />
                    <CardTitle className="card-title" title={ title } subtitle={ Description }
                               titleColor={ titleColor } subtitleColor={ titleColor }
                               titleStyle={ styles.title} subtitleStyle={ subtitleStyle }
                               style={ cardTitleStyle }/>
                </div>
            );

            const cardId = debug_ui && <span style={{ position: 'absolute' }}>{id}</span>;

            const onTap = () => (this.props.onTouchTap || this.onPaperTap)( link || undefined );

            return (
                <div className={`grid-card ${icon_big ? 'card-icon-big-holder':''}`} style={ outerStyles }>
                    { cardId }
                    <CardPaper {...props} style={ innerStyles } onTouchTap={onTap.bind(this)}>
                        { cardContent }
                    </CardPaper>
                    { children }
                </div>
            );
        }
    }
}

export default Card



// WEBPACK FOOTER //
// ./ui/c/card/index.jsx